import { css } from '@inter-ikea-kompis/web-component';

import type IWoodDeclarationStyleOptions from '../../types/IWoodDeclarationStyleOptions.js';

export default class WoodDeclarationCardStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options.
	 * @param options.theme Theme.
	 * @returns Styles.
	 */
	public static getStyle(options: IWoodDeclarationStyleOptions): string {
		const { color, spacing } = options.theme;

		return css`
			.container {
				display: flex;
				flex-direction: column;
			}
			kompis-text {
				color: ${color.text.default};
			}
			.row {
				display: flex;
				flex-direction: column;
				margin-bottom: ${spacing.space100 / 16}rem;
			}
			.row:last-child {
				margin-bottom: 0;
			}
			.woodDeclarationHeader {
				color: ${color.text.dark};
				padding-bottom: ${spacing.space150 / 16}rem;
			}
		`;
	}
}
